const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const trim = require('lodash/string/trim');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerMiFIDUSPersonModal = require('mifid/components/brokerMiFIDUSPersonModal/brokerMiFIDUSPersonModal');

// @actions
const BrokerConvenienceMiFIDTestAction = require('mifid/actions/brokerConvenienceMiFIDTest');

// @constants
const {
    BROKER_PG_URL,
    BROKER_MIFID_VERSION_1,
    BROKER_MIFID_VERSION_2,
    MYPROFILE_BROKER_SUBSCRIPTION_WIZARD_URL
} = require('constants/index');

class BrokerMiFIDBehavior extends React.Component {
    constructor(props) {
        super(props);

        const usPersonDisclaimerAlreadyDisplayed = !!props.immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonOperationCode']);
        const operationCodeWasUse = props.immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'operationCodeWasUse']);

        this.state = {
            mustCheckMifid: true,
            canContinue: (
                (props.mifidVersion === BROKER_MIFID_VERSION_1) ||
                ((props.mifidVersion === BROKER_MIFID_VERSION_2 && usPersonDisclaimerAlreadyDisplayed && !operationCodeWasUse) ||
                (props.mifidVersion === BROKER_MIFID_VERSION_2 && props.continuationUrl === MYPROFILE_BROKER_SUBSCRIPTION_WIZARD_URL))
            )
        };

        this.handleStartMifid = this.handleStartMifid.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
    }

    componentDidMount() {
        this.handleStartMifid(this.props);
    }

    // (franco.montenegro) Use componentWillReceiveProps instead of
    // componentWillMount since some props might not be set (some of them
    // are fetched using services)
    componentWillReceiveProps(newProps) {
        this.handleStartMifid(newProps);
    }

    handleStartMifid(props) {
        const { mustCheckMifid, canContinue } = this.state;
        const productName = trim(props.productName);
        const productUrl = trim(props.productUrl);
        const productMifidId = trim(props.productMifidId);
        const invalidProductMifidId = productMifidId.length === 0;

        if (!mustCheckMifid || !canContinue) {
            return;
        }

        if (!productName) {
            return;
        }

        if (props.mifidVersion === BROKER_MIFID_VERSION_1 && invalidProductMifidId) {
            return;
        }

        this.setState({ mustCheckMifid: false });

        props.onStartMifid(
            props.history,
            productName,
            productUrl,
            productMifidId,
            props.continuationUrl,
            props.mifidOptions,
            props.cancelPath
        );
    }

    handleContinue() {
        this.setState({ canContinue: true });
        this.handleStartMifid(this.props);
    }

    isUsingMifidVersion2() {
        return this.props.mifidVersion === BROKER_MIFID_VERSION_2;
    }

    testResultWasDisplayed() {
        const { immBrokerConvenienceMiFIDTest } = this.props;
        return immBrokerConvenienceMiFIDTest.get('resultDisplayed');
    }

    buildMifidContentOrLoading() {
        const { displayWhileLoading, mifidOptions } = this.props;
        const mustRefreshOperationCode = this.props.immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'operationCodeWasUse']);
        const { canContinue } = this.state;
        const canNotContinue = !canContinue;
        if (canContinue && displayWhileLoading) {
            return <LoadingSection/>;
        } else if (canNotContinue || mustRefreshOperationCode) {
            return (
                <BrokerMiFIDUSPersonModal
                    operationType={
                        !!mifidOptions.operationType
                            ? mifidOptions.operationType
                            : null
                    }
                    displayWhileLoading={this.props.displayWhileLoading}
                    onContinueOperation={this.handleContinue}
                    onCancel={this.props.onCancel}
                    isinId={this.props.productIsinId}
                    marketId={this.props.productMarketId}
                    feeNumbers={this.props.feeNumbers}
                    valueCode={this.props.valueCode}
                    eventCode={this.props.eventCode}
                />
            );
        }
    }

    buildMifidContentIfRequired() {
        const testResultWasNotDisplayed = !this.testResultWasDisplayed();

        if (testResultWasNotDisplayed && this.isUsingMifidVersion2()) {
            return this.buildMifidContentOrLoading();
        }
    }

    buildChildrenIfRequired() {
        const doNotDisplayLoading = !this.props.displayWhileLoading;

        if (this.testResultWasDisplayed() || doNotDisplayLoading) {
            return this.props.children;
        }
    }

    render() {
        return (
            <span>
                {this.buildMifidContentIfRequired()}
                {this.buildChildrenIfRequired()}
            </span>
        )
    }
}

BrokerMiFIDBehavior.propTypes = {
    mifidVersion: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    productUrl: PropTypes.string.isRequired,
    continuationUrl: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]),
    productIsinId: PropTypes.string,
    productMarketId: PropTypes.string,
    feeNumbers: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    valueCode: PropTypes.string,
    eventCode: PropTypes.string,
    productMifidId: PropTypes.string,
    mifidOptions: PropTypes.object,
    history: PropTypes.object,
    onCancel: PropTypes.func,
    children: PropTypes.any,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    onStartMifid: PropTypes.func.isRequired,
    displayWhileLoading: PropTypes.bool,
    cancelPath: PropTypes.string
};

BrokerMiFIDBehavior.defaultProps = {
    mifidVersion: BROKER_MIFID_VERSION_1,
    displayWhileLoading: true,
    onCancel: () => this.props.history.push(BROKER_PG_URL)
};

module.exports.BrokerMiFIDBehavior = connect(
    (state) => ({ immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest }),
    {
        onStartMifid: BrokerConvenienceMiFIDTestAction.start
    }
)(withRouter(BrokerMiFIDBehavior));
